import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import type { Todo } from 'shared-types';

@Injectable({ providedIn: 'root' })
export class TodoService {
  private base = '/api'; // via Proxy zur API
  http: HttpClient = inject(HttpClient);

  list(wallet?: string): Observable<Todo[]> {
    const params = wallet ? `?wallet=${encodeURIComponent(wallet)}` : '';
    return this.http.get<Todo[]>(`${this.base}/todos${params}`);
  }

  listPersonal(wallet: string): Observable<Todo[]> {
    return this.http.get<Todo[]>(`${this.base}/todos/personal?wallet=${encodeURIComponent(wallet)}`);
  }

  listGlobal(): Observable<Todo[]> {
    return this.http.get<Todo[]>(`${this.base}/todos/global`);
  }

  create(title: string, creator: string, isGlobal: boolean): Observable<Todo> {
    return this.http.post<Todo>(`${this.base}/todos`, { title, creator, isGlobal });
  }

  toggle(id: number, wallet?: string): Observable<Todo> {
    return this.http.patch<Todo>(`${this.base}/todos/${id}/toggle`, { wallet });
  }

  delete(id: number, wallet: string): Observable<Todo> {
    return this.http.delete<Todo>(`${this.base}/todos/${id}`, { body: { wallet } });
  }
}
